<template>
  <Panel>
    <div class="banner-panel relative" slot="panel">
      <img class="banner-img absolute" src="@/assets/img/banner.png" alt="">
      <div class="banner-title absolute">
        <div :class="['title line-small', font40]"><span class="weight-bold">{{$root.language.homeRow1}}</span>
          {{$root.language.homeRow2}}</div>
        <div class="title font-40 weight-bold text-red">{{$root.language.homeRow3}}</div>
        <ul class="weight-bold font-26">
          <li class="padding-left-25">
            <a-icon class="text-red" :style="iconColor" type="caret-right" />{{$root.language.homeRow4}}</li>
          <li class="padding-left-25">
            <a-icon class="text-red" :style="iconColor" type="caret-right" />{{$root.language.homeRow5}}</li>
          <li class="padding-left-25">
            <a-icon class="text-red" :style="iconColor" type="caret-right" />{{$root.language.homeRow6}}</li>
        </ul>
        <div class="font-20 banner-desc">
          <span class="text-red weight-bold">{{$root.language.homeRow7}}</span> {{$root.language.homeRow8}}<br>
          {{$root.language.homeRow9}} <br>
          {{$root.language.homeRow10}}
        </div>
      </div>
    </div>

  </Panel>
</template>

<script>
import Panel from '@/components/panel'
export default {
  components: {
    Panel
  },

  data () {
    return {
      iconColor: {
        color: '#DA4026'
      }
    }
  },
  computed: {
    font40: function () {
      return this.$root.isEnglish ? 'font-40' : 'font-32'
    }
  }
}

</script>

<style scoped>
  .banner-panel {
    min-height: 585px;
  }

  .banner-title {
    z-index: 2;
    top: 90px;
    left: 0;
  }

  .banner-img {
    z-index: 1;
    top: 0;
    right: 0;
    width: 85rem;
    transition: all 1s;
  }

  .banner-title ul {
    margin: 30px 0;
  }

  .padding-left-25 {
    padding-left: 25px;
  }

  @media (max-width: 1200px) {
    html {
      font-size: 12px;
    }
    .banner-img {
      width: 80rem;
    }
  }

  @media (max-width: 992px) {
    .banner-title .title {
      font-size: 2rem;
    }

    .banner-img {
      width: 82rem;
    }

    .banner-title ul li {
      font-size: 1.125rem;
    }

    .banner-desc {
      font-size: 1rem;
    }
  }
  @media (max-width: 578px) {
    .banner-panel {
      min-height: 250px;
    }
    .banner-title {
      top: 20px;
      left: 5px;
    }
    .banner-title .title {
      font-size: 1rem;
    }
    .banner-img {
      width: 24rem;
      left: 0;
    }
    .banner-title ul li {
      font-size: 0.75rem;
    }
    .banner-desc {
      font-size: 0.75rem;
    }
  }
</style>
